<template>
  <div id="prospect-info" class="columns custom-columns is-flex is-vcentered">
    <div
      v-if="name && lastName && email"
      class="column user-data">
      <span class="name">{{ name }} {{ lastName }}</span>
      <span class="email">{{ email }}</span>
    </div>
    <div class="column pl-0 pr-0 is-one-fifth user-avatar is-flex is-align-content-center">
      <AvatarShow :show-default="true" />
    </div>
  </div>
</template>
<script>
import AvatarShow from '@/ui/components/input/avatar/AvatarShow.vue';

export default {
  name: 'ProspectInformation',
  components: { AvatarShow },
  props: {
    name: {
      type: String
    },
    lastName: {
      type: String
    },
    email: {
      type: String
    }
  }
};
</script>
<style>
@media screen and (max-width: 768px) {
  .column.user-data,
  .column.user-avatar{
    padding-top: 0;
    padding-bottom: 0;
    text-align: center;
  }
  .column.user-avatar{
    margin-top: -30px;
    z-index: 4000;
  }
}
@media screen and (min-width: 769px) {
  .column.user-data,
  .column.user-avatar{
    padding-top: 0;
    padding-bottom: 0;
    text-align: right;
  }
  .column.user-data{
    padding-right: 0;
  }
  .column.user-avatar > div{
    margin: 0 auto;
  }
}
@media screen and (min-width: 769px) and (max-width: 930px){
  .column.user-data span{
    font-size: 0.8rem;
  }
}
.user-data span{
  display: block;
}
.user-data span.name{
  color: #4B5C6B;
  display: block;
}
.user-data span.email{
  color: #788896;
}
</style>
